<template>
  <div class="container productBox">
    <div class="productBox_calss">
      <div class="productList">
        <div :class="`productBox_tiems ${clNuObj == '' ? 'actives':''}`" @click="classChange({cl_Nu: ''})">
          <div :class="`circle ${clNuObj == '' ? 'grode':''} `"></div>
          <div class="contents">
            {{ $hs('全部','All','All') }}
            <!-- <span :class="clNuObj == '' ? 'spanActive':''">[{{allNum}}]</span> -->
          </div>
        </div>
        <div
          :class="`productBox_tiems ${clNuObj == item.cl_Nu ? 'actives':''}`"
          v-for="(item, index) in options"
          :key="index"
          :ref="'items'+index"
          @click="classChange(item)"
        >
          <div :class="`circle ${clNuObj == item.cl_Nu ? 'grode':''} `"></div>
          <div class="contents">
            {{ item[$hs('cl_Na','cl_Ne_Na','threeLanguage')] }}
            <span :class="clNuObj == item.cl_Nu ? 'spanActive':''">[{{ item['count'] }}]</span>
          </div>
        </div>
      </div>
    </div>
    <div class="productBox_contents">
      <div class="pro-list">
        <div class="cell" v-for="(item,index) in productList" :key="index">
          <everyProduct :productData="item"></everyProduct>
        </div>
      </div>
      <div class="pagination" v-if="productList.length > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="totalRows"
        ></el-pagination>
      </div>
      <div v-if="productList.length <= 0">
        <el-empty></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { queryPage, getProductCount } from '@/api/product'
import { mapGetters, mapActions } from 'vuex'
import {
  ProductClassWebGetProductCountByClass
} from '@/api/home'
import { insertSearch, insertListView } from '@/api/statistics'
import everyProduct from '@/components/productBox/everyProduct.vue' //单个产品组件
import transformMark from '@/utils/water'
export default {
  components: {
    everyProduct
  },
  data() {
    return {
      productList: [],
      queryParam: {
        pageNo: 1,
        pageSize: 20,
        sortField: '',
        sortOrder: '',
        cl_Nu: '',
        faNos: [],
        coNus: [],
        isAnd: false,
        keywords: '',
        conditionals: [],
        startTime: null
      },
      isShowSearch: true,
      totalRows: 0,
      totalPage: 0,
      classifyItem: {},
      daytimeArr: [],
      clNuObj: 0,
      productInputValue: '',
      loginForm: {
        userAccount: '',
        userPassword: ''
      },
      setMenus: [],
      openeds: [],
      options: [],
      optionsChildren: [],
      // allNum: 0,
      ruleForm: {
        pr_Na: '',
        itemNo: 'co_Nu',
        itemNoValue: '',
        date1: '',
        date2: '',
        cl_Nu: '',
        cl_Nu1: '',
        price1: '',
        price2: '',
        pr_Le: '',
        pr_Wi: '',
        pr_Hi: '',
        sort: 'dateDESC'
      },
      rules: {}
    }
  },
  computed: {
    ...mapGetters('setting', {
      getMenus: 'get_menus'
    }),
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    }),
    ...mapGetters('operate', {
      getEnquiry: 'get_enquiry'
    })
  },

  created() {
    // 重置数据
    this.resetData()

    // 
    this.clNuObj = this.$route.query.clNu || ''
    this.queryParam.cl_Nu = this.clNuObj

    // 首页高级查询查询
    const ruleForm = this.$route.params.ruleForm || {}
    if (ruleForm.itemNo) {
      this.ruleForm = ruleForm
      this.advancedSearchFun()
    }

    // 首页列表综合查询
    const codeForm = this.$route.params.codeForm || {}
    if (codeForm.itemNo) {
      if (codeForm.itemNo === 'co_Nu') {
        this.queryParam.coNus = codeForm ? codeForm.itemNoValue.split('\n') : []
      } else {
        this.queryParam.faNos = codeForm ? codeForm.itemNoValue.split('\n') : []
      }
    }

    this.initData()
    this.getMenusList()
    this.statisticsView()
  },

  destroyed() {
  },
  methods: {
    ...mapActions('operate', {
      batchAddCart: 'batch_add_cart',
      setEnquiry: 'set_enquiry'
    }),
    classChange(optiosn) {
      this.ruleForm = {
        cl_Nu: optiosn.cl_Nu
      }
      this.queryParam.cl_Nu = ''
      this.clNuObj = optiosn.cl_Nu
      this.queryParam.coNus = []
      this.ruleForm.cl_Nu = optiosn.cl_Nu
      this.advancedSearchFun()
      window.open(`/#/product?clNu=${optiosn.cl_Nu}`, '_blank')
    },

    // 统计访问
    statisticsView() {
      if (this.userInfo.id) {
        let obj = {
          mobile: this.userInfo.mobile || '',
          client_Na: this.userInfo.client_Na || '',
          userAccount: this.userInfo.userAccount || '',
          client_Nu: this.userInfo.client_Nu || '',
          pageUrl: this.$route.fullPath || ''
        }
        insertListView(obj).then(() => { })
      }
    },
    dianji() {
      this.$refs.items25[0].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest', // 或 'start' 对齐顶部
      });
    },
    // 统计搜索埋点
    statisticsKeywordsSearch(keywords) {
      if (this.userInfo.id && keywords) {
        const param = {
          mobile: this.userInfo.mobile,
          client_Na: this.userInfo.client_Na,
          userAccount: this.userInfo.userAccount,
          client_Nu: this.userInfo.client_Nu,
          keywords
        }
        insertSearch(param)
      }
    },

    // 重置数据
    resetData() {
      this.ruleForm = {
        pr_Na: '',
        itemNo: 'co_Nu',
        itemNoValue: '',
        date1: '',
        date2: '',
        cl_Nu: '',
        cl_Nu1: '',
        price1: '',
        price2: '',
        pr_Le: '',
        pr_Wi: '',
        pr_Hi: '',
        sort: 'dateDESC'
      }
      this.queryParam = {
        pageNo: 1,
        pageSize: 20,
        sortField: '',
        sortOrder: '',
        cl_Nu: '',
        faNos: [],
        coNus: [],
        isAnd: false,
        keywords: '',
        conditionals: [],
        startTime: null
      }
    },

    resetForm() {
      this.resetData()
      this.$router.push('/product')
      this.advancedSearchFun()
    },

    sortChange() {
      this.advancedSearchFun()
    },
    // 构建复杂查询条件
    advancedSearchFun() {
      const conditionals = []
      this.queryParam.keywords = ''
      this.queryParam.sortField = ''
      this.queryParam.sortOrder = ''
      this.queryParam.isAnd = true
      let formData = this.ruleForm
      this.clNuObj = formData['cl_Nu']
      console.log(formData)
      for (const key in formData) {
        if (key === 'pr_Na' && formData[key]) {
          conditionals.push({
            conditionalType: 1,
            fieldName: this.$hs('pr_Na', 'pr_En_Na', 'basicThreeLanguage'),
            fieldValue: formData[key]
          })
          this.queryParam.keywords = formData[key]
        } else if (key === 'itemNoValue' && formData[key]) {
          switch (formData.itemNo) {
            case 'co_Nu':
              conditionals.push({
                conditionalType: 1,
                fieldName: 'co_Nu',
                fieldValue: formData[key]
              })
              break
            case 'fa_No':
              conditionals.push({
                conditionalType: 1,
                fieldName: 'fa_No',
                fieldValue: formData[key]
              })
              break
          }
        }
        else if (key === 'ou_Lo1' && formData[key]) {
          conditionals.push({
            conditionalType: 3,
            fieldName: 'ou_Lo',
            fieldValue: formData[key]
          })
        } else if (key === 'ou_Lo2' && formData[key]) {
          conditionals.push({
            conditionalType: 5,
            fieldName: 'ou_Lo',
            fieldValue: formData[key]
          })
        } else if (key === 'date1' && formData[key]) {
          conditionals.push({
            conditionalType: 3,
            fieldName: 'createdTime',
            fieldValue: formData[key] + ' 00:00:00'
          })
        } else if (key === 'date2' && formData[key]) {
          conditionals.push({
            conditionalType: 5,
            fieldName: 'createdTime',
            fieldValue: formData[key] + ' 23:59:59'
          })
        } else if (key === 'cl_Nu' && formData[key]) {
          conditionals.push({
            conditionalType: 0,
            fieldName: 'cl_Nu',
            fieldValue: formData['cl_Nu']
          })
        }
        else if (key === 'packMethod' && formData[key]) {
          conditionals.push({
            conditionalType: 1,
            fieldName: 'pa_Nu',
            fieldValue: formData['packMethod']
          })
        }
        else if (key === 'price1' && formData[key]) {
          conditionals.push({
            conditionalType: 3,
            fieldName: 'price',
            fieldValue: formData[key]
          })
        } else if (key === 'price2' && formData[key]) {
          conditionals.push({
            conditionalType: 5,
            fieldName: 'price',
            fieldValue: formData[key]
          })
        } else if (key === 'pr_Le' && formData[key]) {
          conditionals.push({
            conditionalType: 0,
            fieldName: 'pr_Le',
            fieldValue: formData[key]
          })
        } else if (key === 'pr_Wi' && formData[key]) {
          conditionals.push({
            conditionalType: 0,
            fieldName: 'pr_Wi',
            fieldValue: formData[key]
          })
        } else if (key === 'pr_Hi' && formData[key]) {
          conditionals.push({
            conditionalType: 0,
            fieldName: 'pr_Hi',
            fieldValue: formData[key]
          })
        } else if (key === 'sort' && formData[key]) {
          switch (formData[key]) {
            case 'dateDESC':
              this.queryParam.sortField = 'createdTime'
              this.queryParam.sortOrder = 'Dscend'
              break
            case 'dateASC':
              this.queryParam.sortField = 'createdTime'
              this.queryParam.sortOrder = 'ascending'
              break
            case 'priceDESC':
              this.queryParam.sortField = 'price'
              this.queryParam.sortOrder = 'Dscend'
              break
            case 'priceASC':
              this.queryParam.sortField = 'price'
              this.queryParam.sortOrder = 'ascending'
              break
            case 'NO.DESC':
              this.queryParam.sortField = 'co_Nu'
              this.queryParam.sortOrder = 'Dscend'
              break
            case 'NO.ASC':
              this.queryParam.sortField = 'co_Nu'
              this.queryParam.sortOrder = 'ascending'
              break
            default:
              break
          }
        }
      }
      this.queryParam.conditionals = conditionals
      this.initData()
      // this.dianji(index);
    },
    handleClick(e) {
      this.queryParam.cl_Nu = e.name || '0'
      this.initData()
    },
    // 初始化数据
    initData() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('GA.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 带上客户编号
      this.queryParam.client_Nu = this.userInfo.client_Nu || ''
      this.statisticsKeywordsSearch(this.queryParam.keywords)

      queryPage(this.queryParam)
        .then(res => {
          if (res.success) {
            this.productList = res.data.rows.map(item => {
              const ind = this.getEnquiry[0].list.findIndex(
                it => it.co_Nu === item.co_Nu
              )
              if (ind > -1) {
                return { ...item, _num_: true }
              }
              return { ...item, _num_: false }
            })
            this.queryParam.isAnd = false

            this.productList.forEach(item => {
              transformMark(item.imgUrl + '?imageMogr2/thumbnail/800x').then(
                result => {
                  item.imgUrl = result
                }
              )
            })

            this.totalRows = res.data.totalRows
            this.totalPage = res.data.totalPage
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          loading.close()
        })

      // getProductCount({ client_Nu: this.userInfo.client_Nu }).then((res) => {
      //   this.allNum = res.data
      // })
    },

    getMenusList() {
      ProductClassWebGetProductCountByClass().then(res => {
        if (res.success) {
          this.options = res.data
        }
      }).catch(err => {
      })
    },

    visibleChange(e) {
      if (e) {
        this.optionFun()
      }
    },
    optionFun() {
      let childrenList = []
      this.options = this.setMenus
      this.optionsChildren = childrenList
    },

    // 构建复杂查询条件
    buildConditionals(keywords) {
      this.queryParam.keywords = keywords || ''
      const conditionals = []
      const fields = [
        'co_Nu',
        'fa_No',
        'pr_Na',
        'cl_Na',
        'pr_En_Na',
        'basicThreeLanguage'
      ]
      fields.forEach(item => {
        conditionals.push({
          conditionalType: 1,
          fieldName: item,
          fieldValue: keywords
        })
      })
      return conditionals
    },

    // 分页大小操作
    handleSizeChange(pageSize) {
      this.queryParam.pageNo = 1
      this.queryParam.pageSize = pageSize
      this.initData()
    },

    // 分页翻页操作
    handleCurrentChange(pageNo) {
      this.queryParam.pageNo = pageNo
      this.initData()
    }
  }
}
</script>

<style lang="scss" scoped>
.productBox {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  .productBox_calss {
    // position: sticky;
    // top: 2px;
    width: 250px;
    max-height: 736px;
    border: 1px solid #e5e5e5;
    margin-bottom: 50px;
    .productBox_header,
    .productBox_tiems {
      height: 36px;
      line-height: 36px;
      font-size: 12px;
      font-weight: 500;
      text-align: left;
      color: #ffffff;
      display: flex;
      align-items: center;
      cursor: pointer;
      overflow: hidden;
      span {
        color: #ff0000;
      }
    }
    .productBox_tiems {
      background: #fff;
      color: #222222;
      .contents {
        width: 180px;
        white-space: nowrap; /* 禁止换行 */
        overflow: hidden;
        text-overflow: ellipsis; /* 显示省略号 */
      }
      &:hover {
        background: #ff0000;
        color: #fff;
        span {
          color: #fff;
        }
      }
    }
    .circle {
      width: 6px;
      height: 6px;
      background: #dfdfdf;
      border-radius: 50%;
      margin-left: 10px;
      margin-right: 15px;
    }
    .grode {
      background: #fff;
    }
    .productList {
      max-height: 736px;
      overflow: auto;
    }
    // 滚动条宽度
    .productList::-webkit-scrollbar {
      width: 7px;
    }
    // 滚动条轨道
    .productList::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 2px;
    }
    // 小滑块
    .productList::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 10px;
    }
    .productList::-webkit-scrollbar-thumb:hover {
      background: #c1c1c1;
    }

    .actives {
      background: #ff0000;
      color: #fff;
    }
    .spanActive {
      color: #fff !important;
    }
  }
  .productBox_contents {
    width: 940px;
    margin-left: 22px;
    .product_nav {
      font-size: 16px;
      font-weight: 400;
      color: #222222;
      line-height: 26px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      span:hover {
        color: #ff0000;
        cursor: pointer;
      }
    }
    .product_nodata {
      text-align: center;
    }
  }
}
.search {
  width: 100%;
  // height: 412px;
  margin: 20px 0 0 0;
  box-shadow: 0 0 8px 1px #ebebeb;
  padding: 10px 20px;
  box-sizing: border-box;

  .active {
    display: flex;
    justify-content: space-between;
    .btn {
      color: #f2410f;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }
    }
  }

  .flex-box {
    display: flex;
    justify-content: space-between;
    .el-form-item {
      width: 46%;
      margin: 0 !important;

      :deep(.el-form-item__label) {
        padding: 0 !important;
        height: 36px;
        line-height: 36px;
      }

      :deep(.el-radio) {
        margin-right: 5px !important;
      }
    }
  }
  .form-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0 10px;
    & > div {
      width: 120px;
      height: 46px;
      line-height: 45px;
      border-radius: 6px;
      text-align: center;
      color: #fff;
      margin: 0 20px 0 0;
      font-size: 16px;
      cursor: pointer;
    }

    .search-btn {
      background: #f2410f;
    }

    .reset {
      background: #1f1f1f;
    }
  }
}

.pro-list {
  display: flex;
  flex-wrap: wrap;

  .cell {
    width: 220px;
    margin-right: 16px;
    margin-bottom: 20px;
    &:nth-child(4n) {
      margin-right: 0px;
    }
  }
}

.pagination {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}
</style>